import { IController } from 'angular';
export class ReviewOtmStepCtrl implements IController {}
